export enum BigSymbolFreegamesState
{
	Idle,

	IntroMessage,

	WaitFirstSpin,
	//Running,
	Spin,
	Features,
	BigWin,
	Win,
	Bonus,
	Collect,
	SpinIdle,

	//CometCollect,
	FinalMessage,
}